module.exports = "/images/seamless-tax-filings@3x.png?0e82a16b83324e60efcb26934535d475";